import { ImpactOrderVariant } from './impact-order';

export enum TileSource {
  ADMIN_PANEL = 'ADMIN_PANEL',
  API = 'API',
  DONATION = 'DONATION',
  ECOLOGI_FEATURE = 'ECOLOGI_FEATURE',
  FLIGHT_CALCULATOR = 'FLIGHT_CALCULATOR',
  IMPACT_SHOP = 'IMPACT_SHOP',
  SUBSCRIPTION = 'SUBSCRIPTION',
  UNKNOWN = 'UNKNOWN',
}

export const impactOrderVariantToTileSource: Record<ImpactOrderVariant, TileSource> = {
  [ImpactOrderVariant.ADMIN_PANEL]: TileSource.ADMIN_PANEL,
  [ImpactOrderVariant.API]: TileSource.API,
  [ImpactOrderVariant.FLIGHT_CALCULATOR]: TileSource.FLIGHT_CALCULATOR,
  [ImpactOrderVariant.IMPACT_SHOP]: TileSource.IMPACT_SHOP,
  [ImpactOrderVariant.INTEGRATION]: TileSource.API,
  [ImpactOrderVariant.SUBSCRIPTION]: TileSource.SUBSCRIPTION,
};
